import type { MediaCoverage } from "@/lib/mediacoverage";

function formatDate(dateStr: string) {
  const date = new Date(dateStr);
  const month = date.toLocaleString("en", { month: "short" });
  const day = date.getDate();
  const year = date.getFullYear();
  return { month, day, year };
}

interface MediaCoverageCardProps {
  media: MediaCoverage;
}

export default function MediaCoverageCard({ media }: MediaCoverageCardProps) {
  const { month, day, year } = formatDate(media.createdDate);

  return (
    <div className="mc-card">
      <div className="mc-card-date-badge">
        <span className="mc-card-date-day">{day}</span>
        <span className="mc-card-date-month">{month}</span>
        <span className="mc-card-date-year">{year}</span>
      </div>

      <div className="mc-card-body">
        {media.heading && (
          <span className="mc-card-label">{media.heading}</span>
        )}
        <h3 className="mc-card-title">
          {media.externalLink ? (
            <a
              href={media.externalLink}
              target="_blank"
              rel="noreferrer"
              style={{ color: "inherit", textDecoration: "none" }}
            >
              {media.title}
            </a>
          ) : (
            media.title
          )}
        </h3>
        <div
          className="mc-card-desc"
          dangerouslySetInnerHTML={{ __html: media.description }}
        />
        {media.externalLink && (
          <a
            href={media.externalLink}
            target="_blank"
            rel="noreferrer"
            className="mc-card-link"
          >
            Read Full Article
            <i className="fa-solid fa-arrow-up-right-from-square ms-2"></i>
          </a>
        )}
      </div>

      <div className="mc-card-accent" />
    </div>
  );
}
